<script lang="ts">
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'
import moment from 'moment'
import 'moment/dist/locale/fr'
import { HelperService } from '@nuxtDatakodeUtils/utils/helper.service'
import { OpportunityService } from '~/services/opportunity.service'
import { Opportunity } from '~/models/Opportunity'
import CommentData = PildomModules.Voirie.Data.CommentData

export default {
    name: 'OpportunityComments',
    components: {},
    extends: i3pSubComponent,
    props: {
        opportunityData: { type: Object, required: true },
    },
    data() {
        return {
            moment,
            content: '',
            opportunityService: null as OpportunityService,
            isDeletingIndex: null,
            isSaving: false,
        }
    },
    computed: {
        HelperService() {
            return HelperService
        },
    },
    watch: {
        opportunityData() {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
    },
    beforeMount() {
        this.initService()
    },
    mounted() {
        this.moment.locale('fr')
    },
    methods: {
        initService(): void {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
        // deleteLike(likeData: LikeData): void {
        //     this.opportunityService.deleteLike(likeData).then(() => {
        //         this.i3pService.refreshData().then(() => {
        //             this.i3pService.reloadCurrenEntity()
        //         })
        //     })
        // },

        postComment(value): void {
            this.opportunityService.setComment(value).then(() => {
                this.isSaving = true
                const reloadPromise = this.i3pService.reloadCurrenEntity()
                if (!reloadPromise) {
                    return
                }
                reloadPromise.then(() => {
                    this.isSaving = false
                    this.content = ''
                })
            })
        },

        deleteComment(commentData: CommentData): void {
            this.isDeletingIndex = commentData.k
            this.opportunityService.deleteComment(commentData).then(() => {
                this.i3pService.reloadCurrenEntity().then(() => {
                    this.isDeletingIndex = null
                })
            })
        },
    },
}
</script>

<template>
    <FormSection title="Commentaires" with-borders-color="primary">
        <v-row justify="space-between">
            <v-col>
                <span class="text-subtitle-1 font-weight-bold">{{
                    opportunityData.comments.length
                }} commentaire{{ opportunityData.comments.length > 1 ? 's' : '' }}</span>
            </v-col>
            <!-- <v-col class="text-right"> -->
            <!-- Récents | Anciens -->
            <!-- </v-col> -->
        </v-row>
        <div class="mb-5">
            <v-divider class="my-2" />
            <template v-if="opportunityData.meta.commentable">
                <label class="text-subtitle-2" for="nouveau-commentaire">
                    Nouveau commentaire
                </label>
                <v-textarea
                    id="nouveau-commentaire" v-model="content" variant="outlined" hide-details class="mb-1"
                    aria-describedby="nouveau-commentaire"
                />
                <v-btn
                    variant="flat" prepend-icon="mdi-send" size="small" color="primary" :loading="isSaving"
                    @click="postComment(content)"
                >
                    Ajouter mon commentaire
                </v-btn>
            </template>
        </div>

        <v-list v-for="(comment, i) in opportunityData.comments" :key="comment">
            <v-row justify="space-between" class="mx-0 mb-2">
                <v-col class="pa-0">
                    <template v-if="comment.credentials.created_by?.name">
                        <span class="mdi mdi-account font-weight-bold"> <span
                            class="pl-2"
                        >{{ comment.credentials.created_by.name }}</span> </span>
                        <span class="text-medium-emphasis">
                            <span class="mx-2">|</span>
                            <span class="mdi mdi-home"><span class="pl-2">{{ comment.organization.name }}</span> </span>
                            <span class="mx-2">|</span>
                            <span class="mdi mdi-clock-time-five"> <span
                                class="pl-2"
                            >{{ moment(comment.credentials.created_at).fromNow() }}</span></span>
                        </span>
                    </template>
                    <template v-else>
                        <span class="mdi mdi-account font-weight-bold"> <span
                            class="pl-2"
                        >Utilisateur supprimé</span> </span>
                        <span class="text-medium-emphasis">
                            <span class="mx-2">|</span>
                            <span class="mdi mdi-home"><span class="pl-2">{{ comment.organization.name }}</span> </span>
                            <span class="mx-2">|</span>
                            <span class="mdi mdi-clock-time-five"> <span
                                class="pl-2"
                            >{{ moment(comment.credentials.created_at).fromNow() }}</span></span>
                        </span>
                    </template>
                </v-col>
                <v-col v-if="comment.meta.deletable" class="text-right pa-0" cols="1">
                    <v-btn
                        color="danger" variant="text" size="x-small" icon="mdi-delete"
                        :loading="isDeletingIndex === comment.k" @click.prevent="deleteComment(comment)"
                    />
                </v-col>
            </v-row>

            <div v-html="(new HelperService()).addBrAndNbsp(comment.content)" />
            <v-divider v-if="opportunityData.comments.length !== i + 1" class="my-3" />
        </v-list>
    </FormSection>
</template>
